// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yiCK","comment":"styles_comment__yuT0P"};